import { useEffect, useMemo } from 'react'

import { useVisitorChannelContext } from '@liveHelper/context/VisitorChannelContext'
import {
  useStore,
  visitorPrivateActionsSelector,
} from '@liveHelper/models/store'
import { ConsentFeatures } from '@oneToOne/shared/consent/ConsentFeatures'

import { useLocalStorage } from '@core/hooks/useLocalStorage'

/**
 * Hook to retreive the list of disabled features on the widget.
 */
export const useFeaturesEnablement = () => {
  const { updatePrivacyConfiguration } = useStore(visitorPrivateActionsSelector)
  const [features] = useLocalStorage('features')

  const channel = useVisitorChannelContext()

  const featuresObj = useMemo(
    () => ConsentFeatures.fromJSON(features),
    [features],
  )

  const monitoringAllowedByVisitor = !featuresObj?.isDisabled('monitoring')

  useEffect(() => {
    if (!channel) {
      return
    }

    const permission = monitoringAllowedByVisitor
      ? 'PRIVACY_CONFIGURATION_ALLOWED'
      : 'PRIVACY_CONFIGURATION_DENIED'

    updatePrivacyConfiguration?.(permission)
  }, [channel, monitoringAllowedByVisitor, updatePrivacyConfiguration])
}
